import { lazy, Suspense } from 'react'

import { Loader, ThemeWrapper } from '@paysense-india-services/elevate-web'

import '@paysense-india-services/elevate-web/dist/common.css'
import styles from './index.module.scss'

const Snackbar = lazy(() => import('@/components/Snackbar'))

/** PayU Finance branding — matches cashloan payment theme (not LazyPay #db2855 default). */
const PAYU_FINANCE_BRANDING = {
  colors: {
    'brand-color': '#0ABF89',
    'brand-light-color': '#dfebfe',
    'brand-dark-color': '#00AD7D'
  },
  typography: {
    fontFamily: "'Plus Jakarta Sans', sans-serif"
  }
}

const AUTH_FLUX_BRANDING_STORAGE_KEY = 'auth_flux_branding'

export default function LayoutContainer({ children }) {
  return (
    <ThemeWrapper
      defaultBranding={PAYU_FINANCE_BRANDING}
      storageKey={AUTH_FLUX_BRANDING_STORAGE_KEY}
    >
      <Suspense
        fallback={
          <div className="ew-d-flex ew-align-items-center ew-justify-content-center ew-h-100">
            <Loader color="brand" loadingText="Please Wait..." pageLoader size="large" />
          </div>
        }
      >
        <div className={`ew-h-100 ew-bg-secondary ew-d-flex ew-flex-column ${styles.layoutRoot}`}>
          {children}
        </div>
      </Suspense>
      <Snackbar />
    </ThemeWrapper>
  )
}
